//import configVars from "@/config/config_vars";
let appBaseUrl = `https://onesignal.com/api/v1/notifications`;

import axios from "axios";

//import querystring from "querystring";


let sendNotification = ( ids) => {

    let sendNotification = `${appBaseUrl}`;

    let postData= { 
      "app_id": "2acfc378-f4eb-41e8-8fe3-bbd36f4ad13f",
      "contents": {"en": "Push notification"},
      "include_player_ids": ids ,
      "web_buttons": [	
                        {
                          "id": "like-button", 
                          "text": "Like", 
                          "icon": "http://blogs.encamina.com/en-las-nubes/wp-content/uploads/sites/9/2015/11/Love-01.png", 
                          "url": "https://www.peppertix.org"
                        }, 
                        {
                          "id": "read-more-button", 
                          "text": "Read more", 
                          "icon": "http://i.imgur.com/MIxJp1L.png", 
                          "url": "https://www.peppertix.org"
                        }
                      ],
      "android_background_layout": {
                                      "image": "http://files.softicons.com/download/social-media-icons/simple-icons-by-dan-leech/png/256x256/twitter.png", 
                                      "headings_color": "FFFF0000", 
                                      "contents_color": "FF00FF00"
                                    },
      "chrome_web_badge": "https://peppertix.org/images/icons/icon-72x72.png"  
    }


    let axiosConfig = {
      headers: {
          'Content-Type': 'application/json',
          "Authorization": "Basic ZTdiNTgyMjAtYzEzMi00OTgyLTllMjktYTYwYjUyZDg4NTYy",
      }
    };


    let instance = axios.create();
    instance.defaults.headers.common = {};

    return instance.post(`${sendNotification}`, postData,  axiosConfig )

}


export default {
  sendNotification
}
